import React from "react";

const PRICE_LIST_SECTIONS = [
  {
    title: "Landscape Maintenance",
    subText: "All rates are hourly unless otherwise specified",
    items: [
      { label: "Mowing and edging", price: "$50" },
      { label: "Weeding", price: "$50" },
      { label: "Garden Bed Cleanup", price: "$50" },
      { label: "Leaf Clean Up", price: "$50" },
      { label: "Blowing", price: "$50" },
      { label: "Planting and Watering", price: "$50" },
      { label: "Pruning/Deadheading", price: "$50" },
      { label: "General garden care", price: "$50" },
    ],
  },
  {
    title: "Lawn Management",
    subText: "Price subject to change based on cost of seeds and fertilizer",
    items: [
      { label: "Power Raking/Aeration", price: "$100" },
      { label: "Seasonal Fertilization", price: "$40 per 1000 sq ft" },
      { label: "Moss Control Fertilization", price: "$40 per 1000 sq ft" },
      { label: "Overseeding", price: "$45 per 1000 sq ft" },
      { label: "Hedge Trimming", price: "$85" },
      { label: "Power Washing", price: "$100" },
    ],
  },
];

const Footer = () => {
  const sectionStyle = {
    fontSize: "1.25rem",
    fontWeight: 500,
    color: "#2d2d2d",
  };

  return (
    <div className="mt-4 mb-4 faq">
      <div className="mb-2">
        <h3 id="price-list" className="mb-2" style={{ fontSize: "1.5rem" }}>
          Price List 2026
        </h3>
        <div className="mb-3" style={{ fontSize: "0.875rem" }}>
          We are dedicated to delivering exceptional value to each and every
          client. My commitment extends beyond mere transactions, aiming to
          foster great relationships through exceptional service and a
          personable approach. Regardless of your budget constraints, my goal of
          quality and value remains my highest priority.
        </div>
      </div>
      <div className="price-list">
        {PRICE_LIST_SECTIONS.map((section) => (
          <div key={section.title} className="price-list-item">
            <div className="mb-0" style={sectionStyle}>
              {section.title}
            </div>
            <div className="sub-text mb-2">{section.subText}</div>
            <ul style={{ fontSize: "0.875rem" }}>
              {section.items.map((item) => (
                <li key={item.label}>
                  {item.label}
                  <div>
                    <span>{item.price}</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Footer;
